import type { INavItems } from '@/widgets/footer/model/types/footer-nav';
import { useCategoriesStore } from '@/entities/categories/index';

export const useFooterNav = () => {
  const { t, locale } = useI18n();
  const categoriesStore = useCategoriesStore();
  const localePath = useLocalePath();

  const categories = computed(() =>
    categoriesStore.parentCategories.map(category => {
      const categorySlug = category[`slug_${locale.value}`];

      return {
        id: category.id,
        text: category.name,
        slug_en: category.slug_en,
        url: localePath({ name: 'catalog-category', params: { category: categorySlug } }),
      };
    }),
  );

  const itemsList: Ref<INavItems> = computed(() => ({
    firstArray: {
      id: 1,
      text: t('catalog'),
      links: categories.value,
    },
    secondArray: {
      id: 2,
      text: t('company'),
      links: [
        {
          id: 1,
          text: t('aboutCompany'),
          url: localePath('about'),
        },
        {
          id: 2,
          text: t('contacts'),
          url: localePath('contacts'),
        },
        {
          id: 3,
          text: t('forBusiness'),
          url: localePath('for-business'),
        },
        {
          id: 4,
          text: t('pickupPoints'),
          url: localePath('pickup-points'),
        },
        {
          id: 5,
          text: t('frequentlyAskedQuestions'),
          url: localePath('faq'),
        },
        {
          id: 6,
          text: t('deliveryAndPayment'),
          url: localePath('delivery-payment'),
        },
      ],
    },
  }));

  const collapsedIndex: Ref<number> = ref(-1);

  const toggleHandler = (index: number): void => {
    collapsedIndex.value = index;
  };

  return {
    itemsList,
    toggleHandler,
  };
};
